<section class="page-stack">
  <div class="section-header">
    <div>
      <p class="eyebrow mb-1">Access Control</p>
      <h2>Admin Users</h2>
    </div>
  </div>

  <div class="panel p-3">
    <form class="row g-3 align-items-end" (ngSubmit)="create()">
      <div class="col-md-3">
        <label class="form-label">Full name</label>
        <input class="form-control" name="full_name" [(ngModel)]="form.full_name" required>
      </div>
      <div class="col-md-3">
        <label class="form-label">Email</label>
        <input class="form-control" name="email" type="email" [(ngModel)]="form.email" required>
      </div>
      <div class="col-md-2">
        <label class="form-label">Role</label>
        <select class="form-select" name="role" [(ngModel)]="form.role">
          <option value="admin">Admin</option>
          <option value="operations">Operations</option>
          <option value="compliance">Compliance</option>
        </select>
      </div>
      <div class="col-md-2">
        <label class="form-label">Status</label>
        <select class="form-select" name="status" [(ngModel)]="form.status">
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>
      </div>
      <div class="col-md-2">
        <button class="btn btn-accent w-100" [disabled]="saving || !form.full_name || !form.email">
          {{ saving ? 'Creating...' : 'Create user' }}
        </button>
      </div>
    </form>
  </div>

  <div class="panel">
    <div class="table-responsive">
      <table class="table table-dark table-hover align-middle mb-0">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Role</th>
            <th>Status</th>
            <th>Password</th>
            <th class="text-end">Actions</th>
          </tr>
        </thead>
        <tbody>
          @if (loading) {
            <tr><td colspan="6" class="text-center py-4">Loading admin users...</td></tr>
          } @else if (users.length === 0) {
            <tr><td colspan="6" class="text-center py-4 text-muted-soft">No admin users created yet.</td></tr>
          } @else {
            @for (user of users; track user.id) {
              <tr>
                <td class="fw-semibold">{{ user.full_name }}</td>
                <td>{{ user.email }}</td>
                <td>{{ user.role }}</td>
                <td>
                  <span class="status-pill" [class.status-muted]="user.status !== 'active'">{{ user.status }}</span>
                </td>
                <td>
                  @if (user.force_password_change) {
                    <span class="badge rounded-pill text-bg-warning">Change required</span>
                  } @else {
                    <span class="text-muted-soft">Current</span>
                  }
                </td>
                <td>
                  <div class="table-actions">
                    <button class="btn btn-sm btn-outline-light" type="button" (click)="toggleStatus(user)">
                      {{ user.status === 'active' ? 'Deactivate' : 'Activate' }}
                    </button>
                    <button class="btn btn-sm btn-outline-info" type="button" (click)="resetPassword(user)">
                      Reset password
                    </button>
                  </div>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>

    <div class="pagination-row">
      <span>Page {{ page }} of {{ totalPages }}</span>
      <div class="btn-group btn-group-sm">
        <button class="btn btn-outline-light" (click)="go(-1)" [disabled]="page === 1">Prev</button>
        <button class="btn btn-outline-light" (click)="go(1)" [disabled]="page === totalPages">Next</button>
      </div>
    </div>
  </div>

  @if (notice) {
    <div class="alert alert-info">{{ notice }}</div>
  }
  @if (error) {
    <div class="alert alert-danger">{{ error }}</div>
  }
</section>
